import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-264e168e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-timeline" }
const _hoisted_2 = { class: "hd-epic-timeline__content hd-container" }
const _hoisted_3 = { class: "hd-epic-timeline__sidebar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_citations_module = _resolveComponent("citations-module")!
  const _component_sidebar_timeline = _resolveComponent("sidebar-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent), {
        section: _ctx.activeSection,
        frame: _ctx.activeFrame
      }, null, 8, ["section", "frame"])),
      (_ctx.hasEndpointData)
        ? (_openBlock(), _createBlock(_component_citations_module, {
            key: 0,
            citations: _ctx.endpointData?.citations,
            "hide-handle": true
          }, null, 8, ["citations"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_sidebar_timeline)
    ])
  ]))
}